import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'> 
    <h5>What I offer</h5> 
    <h2>Services</h2>

    <div className="container services_container">
      <article className="service">
        <div className="service_head">
          <h3>UI/UX Design</h3>
        </div>
        <ul className='service_list'>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Website based on Modern UI/UX</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Made more than 3+ project</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Customer collaboration</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Fast Delivery</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Continuous Support</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Up to date tools for better performance</p>
          </li>
                    
        </ul>
      </article>
      {/* END OF UI/UX */}
      <article className="service">
        <div className="service_head">
          <h3>Web Development</h3>
        </div>
        <ul className='service_list'>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Fully Responsive Website compatilble with all types device </p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Industrial Standard</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Made with latest tools for better performance</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>With Hosting and Database Management</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Continuous Update based on customer updates</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Made 6+ Project</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Customer Collaboration for better results</p>
          </li>
                    
        </ul>
      </article>

      <article className="service">
        <div className="service_head">
          <h3>Graphic Designing</h3>
        </div>
        <ul className='service_list'>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Extensive Knowledge of CorelDraw & Canva</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Made more than 1000+ Design </p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>More than 30 Clients</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Complete solution for commercial printing design</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Affordable Rates</p>
          </li>
          <li>
          <BiCheck className='service_list-icon' />
          <p>Customer Collaboration for better results</p>
          </li>
                    
        </ul>
      </article>
    </div>
    </section>
  )
}

export default Services